<template>
  <div class="btnK" @click="showModalBox" :type="type">
      {{ text }}
  </div>
</template>

<script>
export default {
  text: "Button",
  props: {
     type: {
      default: 'open',
     },
     text: {
      default: '',
     }
  },
  methods: {
     showModalBox(e){
      e.stopPropagation();
      e.preventDefault();
      const width = window.innerWidth;
      if(this.type === 'scroll'){
      let heightOfProtests = document.getElementById("protests-section").offsetTop -100
          window.scroll({
          top: heightOfProtests,
          left: 0,
        });
      }else {
   if (width > 997) {
      this.$root.$emit('toggleModalInvitation', true);
      }else {
           let heightOfProtests = document.getElementById("how__form").offsetTop -100;
          window.scroll({
          top: heightOfProtests,
          left: 0,
        });
      }
      }
      
   
    }
  }
};
</script>
<style lang="scss">
.btnK {
  min-width: 14rem;
  font-size: 1.125rem;
  text-align: center;
  color: #fff;
  padding: 0.8rem 1rem;
  background-color: #FF6436;
  border: 1px solid #FF6436;
  border-radius: 34.5px;
  display: inline-block;
  font-weight: 500;
  text-transform: uppercase;
  font-family: 'Inter', sans-serif;
  transition: .5s all;
  cursor: pointer;
  @media (min-width: 1600px) {
    font-size: 1.5rem;
     min-width: 17.5rem;
      padding: 1.34rem 0.35rem;
      line-height: 1.2;
  }
  &:hover {
    background-color: #fff;
    color: #FF6436;
    cursor: pointer;
  }
}
</style>
